import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BLOCK } from '../../constants/common';
import { Block } from './blocks';
import { CardPriceBlock } from './blocks/CardPriceBlock';
import { Button } from './buttons';
import { Subtitle } from './text';
import { Currency } from '../sell/adverts/Currency';
import { currencyRatesSelector } from '../../redux/reducers/common/common_reducers/currencyRates';

export const TopPriceBlock = ({
    subtitle,
    price,
    onClick,
    priceLabel,
    buttonLabel,
}) => {
    const { t } = useTranslation();
    const rates = useSelector(currencyRatesSelector);
    const hasRates = rates && rates.usd && rates.eur;

    const renderPrice = () => {
        if (priceLabel) {
            return <span className="currency-container">{priceLabel}</span>;
        }
        if (hasRates) {
            return <Currency item={price} />;
        }
        return (
            <span className="currency-container">
                {price}
                {' $'}
            </span>
        );
    };

    return (
        <Block name={BLOCK.COLUMN}>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            <CardPriceBlock>{renderPrice()}</CardPriceBlock>
            <Button text={buttonLabel || t('buy')} onClick={onClick} />
        </Block>
    );
};
